import { DEFAULT_EXPOSURE_BUCKET } from "shared/constants";

import { SelectOption } from "features/ui/Select";

/**
 * Analytics Pages (Claim Analytics, Repair Analytics, Inspection Analytics ..)
 */
export const BY_VEHICLES_AGE_TAB_KEY = "by-vehicle-age";

export const TOP_CONTRIBUTORS_TAB_KEY = "top-contributors";

export const ASSOCIATED_VEHICLES_TAB_KEY = "associated-vehicles";

export const ASSOCIATED_SIGNAL_EVENTS_TAB_KEY = "associated-signal-events";

export const GROUP_BY_ATTRIBUTE_KEY = "groupByAttribute";

export const MONTHS_IN_SERVICE_EXPOSURE_BUCKET: SelectOption = {
  id: DEFAULT_EXPOSURE_BUCKET,
  value: DEFAULT_EXPOSURE_BUCKET,
  label: DEFAULT_EXPOSURE_BUCKET,
};

export type YAxisValTopContributors =
  | "DPTV"
  | "IPTV"
  | "CPV"
  | "totalCost"
  | "numSignalEventOccurrences"
  | "numEvents"
  | "numVehicles"
  | "cost"
  | "downtimeHours";

/**
 * All pages
 */
export const CREATE_CTA_TEXT = "Create";
export const CANCEL_CTA_TEXT = "Cancel";
